import { AccessDeniedError, UnexpectedError } from "../../domain/errors";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { Cargo, NormalizedCargoItem } from "../../domain/models/cargo-model";
import { LoadTransfer } from "../../domain/usecases/load-transfer";
import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbLoadTransfer implements LoadTransfer {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}
  async load(): Promise<NormalizedCargoItem[]> {
    const res = await this.httpClient.request({
      url: this.url,
      method: "get",
    });
    switch (res.statusCode) {
      case HttpStatusCode.ok:
        return res.body;
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError();
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();
      default:
        throw new UnexpectedError();
    }
  }
}
